import { render, staticRenderFns } from "./EmiPaymentReceipt.vue?vue&type=template&id=128949a1&scoped=true"
import script from "./EmiPaymentReceipt.vue?vue&type=script&lang=js"
export * from "./EmiPaymentReceipt.vue?vue&type=script&lang=js"
import style0 from "./EmiPaymentReceipt.vue?vue&type=style&index=0&id=128949a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128949a1",
  null
  
)

export default component.exports